import React from 'react';
import ClaimFieldsTable from './ClaimFieldsTable';
export default function ClaimCalculationsQETable(_ref) {
  let {
    claim,
    setClaim,
    calculations,
    refreshCalculations
  } = _ref;
  const infoFromClaimCalculationsQeRows = [{
    text: 'Qualifying Expenditure under old RDEC',
    field: {
      name: 'prorated_total_qualifying_rnd_expenditure'
    },
    shouldDisplay: claim.rate_types_qualified_for.rdec
  }, {
    text: 'Qualifying Expenditure under RDEC merged scheme',
    field: {
      name: 'prorated_total_qualifying_rnd_expenditure'
    },
    shouldDisplay: claim.rate_types_qualified_for.merge_type
  }, {
    text: 'Qualifying Expenditure under old SME scheme',
    field: {
      name: 'prorated_total_qualifying_rnd_expenditure'
    },
    shouldDisplay: claim.rate_types_qualified_for.sme
  }, {
    text: 'Qualifying Expenditure under ERIS',
    field: {
      name: 'prorated_total_qualifying_rnd_expenditure'
    },
    shouldDisplay: claim.rate_types_qualified_for.eris
  }];
  return /*#__PURE__*/React.createElement(ClaimFieldsTable, {
    calculations: calculations,
    refreshCalculations: refreshCalculations,
    claim: claim,
    setClaim: setClaim,
    title: "Info from calculations of QE",
    rows: infoFromClaimCalculationsQeRows
  });
}